import { ApiClient } from '~/apiclient/apiclient'
import { BroadcasterApi } from '~/apiclient/apibroadcasters'
import { SpeakerApi } from '~/apiclient/apispeakers'
import { SermonApi } from '~/apiclient/apisermons'
import { SeriesApi } from '~/apiclient/apiseries'
import { HashtagApi } from '~/apiclient/apihashtags'
import { DisplayArticleApi } from '~/apiclient/apiarticles'
import { Collection } from '~/models/collection'
import { clone } from '~/assets/ts/utils/misc'
import { SetParamsArrayFormat } from '~/assets/ts/utils/params'

export enum SearchFor {
  Sermon = 'Sermon',
  Broadcaster = 'Broadcaster',
  Speaker = 'Speaker',
  Series = 'Series',
  Hashtag = 'Hashtag',
  VideoSermon = 'VideoSermon',
  Article = 'Article',
}

export enum MultiSearchSort {
  Relevance = 'relevance',
  Latest = 'latest',
  Downloads = 'downloads',
  Event = 'event',
  Language = 'language',
  Series = 'series',
  PickDate = 'pickdate',
  Speaker = 'speaker',
  Title = 'title',
  Oldest = 'oldest',
  NewestPublished = 'newest-published',
  Added = 'added',
  Updated = 'updated',
  LastPlayed = 'lastplayed',
  Comments = 'comments',
}

export interface SearchRequestOptions {
  page?: number
  pageSize?: number
  lite?: boolean
  liteBroadcaster?: boolean
  query?: string
  searchFor?: SearchFor | SearchFor[]
  includeTranscripts?: boolean
  sortBy?: MultiSearchSort
}

export interface MultiSearchResults {
  articleResults: DisplayArticleApi[]
  broadcasterResults: BroadcasterApi[]
  collectionResults: Collection[]
  hashtagResults: HashtagApi[]
  seriesResults: SeriesApi[]
  sermonResults: SermonApi[]
  speakerResults: SpeakerApi[]
  videoSermonResults: SermonApi[]
  nodeType: 'search'
  nodeDisplayName: 'Search'
  next: string | null
}

export async function getMultiSearch(
  this: ApiClient,
  options: Partial<SearchRequestOptions>
): Promise<MultiSearchResults> {
  // searchFor needs to be comma-delimited
  const params = SetParamsArrayFormat(clone(options), 'comma')

  // Just using `options.query` in the params results in axios converting spaces to pluses. This is sufficient most of
  // the time, but for some search terms like "The Impossibility of the Christian Life, Part 4", encoding is necessary.
  // If we simply encode and then pass it in to the params like normal, then axios converts %20 into %2025 which breaks.
  // So to resolve this, we have to use the encoded value directly in the string instead of in the params.
  let search = options.query || ''
  search = encodeURIComponent(search)
  if (params.query) {
    delete params.query
  }
  params.lite = options.lite ?? true
  params.liteBroadcaster = options.liteBroadcaster ?? true
  const { data } = await this.$axios.get(`node/search?query=${search}`, {
    params,
  })

  return data
}
